import { useState } from "react";
import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";

const loremText = `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`;

export default function LoremIpsumGenerator() {
  const [paragraphs, setParagraphs] = useState(3);
  const [output, setOutput] = useState("");

  const generateLorem = () => {
    const para = Array.from({ length: paragraphs }, () => loremText).join("\n\n");
    setOutput(para);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(output);
    alert("Copied to clipboard!");
  };

  return (
    <>
      <Helmet>
        <title>Lorem Ipsum Generator - Free Dummy Text Generator for Design & Content</title>
        <meta
          name="description"
          content="Generate Lorem Ipsum dummy text paragraphs instantly for design, content, and layout purposes. Free and easy-to-use online tool for designers and developers."
        />
        <meta name="keywords" content="lorem ipsum generator, dummy text generator, generate lorem ipsum, free text generator, placeholder text tool, design text generator" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://freelity.com/lorem-ipsum-generator" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2>Lorem Ipsum Generator</h2>

          <div className="form-group mb-3">
            <label>Number of Paragraphs: {paragraphs}</label>
            <input
              type="range"
              min="1"
              max="10"
              value={paragraphs}
              className="form-range"
              onChange={(e) => setParagraphs(Number(e.target.value))}
            />
          </div>

          <button className="btn btn-primary mb-3" onClick={generateLorem}>
            Generate Text
          </button>

          {output && (
            <>
              <textarea
                rows="10"
                className="form-control mb-3"
                value={output}
                readOnly
              />
              <button className="btn btn-success" onClick={copyToClipboard}>
                Copy to Clipboard
              </button>
            </>
          )}
        </div>
      </section>
    </>
  );
}
